module.exports = "https://syscdn.233leyuan.com/233xyx-app-new/1616915989142/static/img/operate_gif.533d5375.gif";